import { IConfig } from './'

export const DemoConfig: IConfig = {
  apiServerHost: 'response-collector-demo.herokuapp.com',
  apiServerPort: 443,
  ssl: true,
  googleOAuthClientId: '',
}



// WEBPACK FOOTER //
// ./src/config/demo.ts